var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[(true)?_c('div',{staticClass:"list-none"},[_c('img',{attrs:{"src":require("../../../assets/list-none.png"),"alt":""}}),_c('div',[_vm._v("空荡荡的~暂无数据！")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }